module.exports = "pegasus/assets/blocks/column-18-theme3.png";